import { IPrice, IPriceCreate, IPriceUpdate } from '../typing/price.interface';

export class Price {
    data: IPrice;

    constructor(data: IPrice){
        this.data = data;
    }

    dataForCreate(formData: IPriceCreate): IPriceCreate{
        return {
            price: formData.price,
            discountPrice: formData.discountPrice ? formData.discountPrice : null,
            duration: formData.duration,
            categoryId: formData.categoryId,
            workId: formData.workId,
            externalPriceId: formData.externalPriceId || null,
        };
    }

    dataForUpdate(formData: IPriceCreate): IPriceUpdate {
        return {
            id: this.data.id,
            price: formData.price,
            discountPrice: formData.discountPrice ? formData.discountPrice : null,
            duration: formData.duration,
            categoryId: formData.categoryId,
            workId: formData.workId,
            externalPriceId: formData.externalPriceId || null,
        };
    }

    formData(): IPriceCreate {
        return {
            price: this.data.price,
            discountPrice: this.data?.discountPrice || null,
            duration: this.data.duration,
            categoryId: this.data.category?.id,
            workId: this.data.work?.id,
            externalPriceId: this.data.externalPrice?.id || null,
        };
    }
}
